import { render, staticRenderFns } from "./StatisticCharts.vue?vue&type=template&id=8a907f9c&scoped=true&"
import script from "./StatisticCharts.vue?vue&type=script&lang=ts&"
export * from "./StatisticCharts.vue?vue&type=script&lang=ts&"
import style0 from "./StatisticCharts.vue?vue&type=style&index=0&id=8a907f9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a907f9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
